// src/context/AppContext.js
import React, { createContext, useState } from 'react';

// Create Context
export const AppContext = createContext();

// Create Provider Component
export const AppProvider = ({ children }) => {
  const [workspaces, setWorkSpaces] = useState([]);
  const [viewerEmails, setViewerEmails] = useState([]);
  const [pipelines, setPipelines] = useState([]);
  const [workSpaceReports, setWorkSpaceReports] = useState([]);
  const [selectedWorkspace, setSelectedWorkspace] = useState();
  const [selectedTableData, selSelectedTableData] = useState();
  const [selectedField, setSelectedField] = useState();
  const [selectedValue, setSelectedValue] = useState([]);
  const [selectedReport, setSelectedReport] = useState();
  const [selectedPipeline, setSelectedPipeline] = useState();
  const [selectedReportTitle, setSelectedReportTitle] = useState();
  const [selectedTable, setselectedTable] = useState();
  const [tableReport, setTableReport] = useState();
  const [fieldTable, setfieldTable] = useState();
  const [ValueField, setValueField] = useState([]);
  const [userId, setUserId] = useState("");
  const [bookmarks, setBookMarks] = useState([]);
  const [isEditMode, setEditMode] = useState(false);
  const [modal, setModal] = useState(false);
  const [activeTab, setActiveTab] = useState("reports");
  const [item, setItem] = useState();
  const [isPowerBi, setPowerBi] = useState(false);
  const [embedToken, setEmbedToken] = useState();
  const [groupRollups, setGroupRollups] = useState([]);
  const [selectedReportId, setSelectedReportId] = useState();
  const [ApplicationOption, setApplicationOption] = useState([])
  const [selectapplication, setSelectapplication] = useState([])
  const [userApplications, setUserApplications] = useState([]);
  const [selectedRoles, setSelectedRoles] = useState([]); // Store selected roles
  const [titleSearchterm, setTitleSearchterm] = useState("")
  const [segSearchTerm, setSegSearchTerm] = useState("")
  const [reportUrls, setReportUrls] = useState([]);
  const [viewerReports, setViewerReports] = useState([]);
  const [rlsType, setRlsType] = useState("report");
  const [currentPage, setCurrentPage] = useState(1);

  const [loader, setLoader] = useState(false);
  const [toast, setToast] = useState({
    show: false,
    type: "",
    message: ""
  });
  const [confirmationModal, setConfirmationModal] = useState({
    show: false,
    id: ""
  })
  const [confirmationModalRls, setConfirmationModalRls] = useState({
    show: false,
    id: "",
    reportId: ""
  })


  const [confirmationModalRlsMail, setConfirmationModalRlsMail] = useState({
    show: false,
    userId: "",
    userId: ""
  })


   const [confirmationModalDeleteMail, setConfirmationModalDeleteMail] = useState({
    show: false,
    userId: "",
    mail: ""
  })
   const [confirmationModalDeleteMailForAbramBi, setConfirmationModalDeleteMailForAbramBi] = useState({
    show: false,
    userId: "",
    mail: ""
  })


  const [confirmationModalInput, setConfirmationModalInput] = useState({
    show: false,
    id: "",
  })
  const [viewerUsers, setViewerUsers] = useState([]);

  const [fetchUrlInReport, setfetchUrlInReport] = useState([])
  const [reportId, setReportId] = useState([])
  const [roles, setRoles] = useState([])
  const [reportOptions, setReportOptions] = useState();
  const [allApplication, setAllApplication] = useState([])
  const [emailOptionTitle, setemailOptionTitle] = useState([])
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  return (
    <AppContext.Provider value={{segSearchTerm, setSegSearchTerm,confirmationModalDeleteMailForAbramBi, setConfirmationModalDeleteMailForAbramBi, currentPage, setCurrentPage, viewerUsers, isDropdownOpen, setIsDropdownOpen, setViewerUsers, emailOptionTitle, setemailOptionTitle, rlsType, setRlsType, reportId, setReportId, allApplication, setAllApplication, reportUrls, setReportUrls, titleSearchterm, setTitleSearchterm, selectedReportTitle, setSelectedReportTitle, activeTab, embedToken, groupRollups, setGroupRollups, setEmbedToken, item, isPowerBi, setPowerBi, setItem, setActiveTab, viewerReports, setViewerReports, modal, setModal, isEditMode, setEditMode, bookmarks, setBookMarks, workSpaceReports, selectedTableData, selectedField, setSelectedField, selSelectedTableData, selectedTable, setselectedTable, tableReport, setTableReport, userId, setUserId, selectedWorkspace, selectedReport, selectedPipeline, setSelectedPipeline, setSelectedReport, setSelectedReportId, selectedReportId, setSelectedWorkspace, setWorkSpaceReports, viewerEmails, setViewerEmails, pipelines, setPipelines, loader, workspaces, setWorkSpaces, setLoader, toast, setToast, confirmationModal, confirmationModalRls, setConfirmationModalRls, setConfirmationModal, roles, setRoles, reportOptions, setReportOptions, fieldTable, setfieldTable, ValueField, setValueField, selectedValue, setSelectedValue, setConfirmationModalInput, setConfirmationModalDeleteMail,confirmationModalDeleteMail,confirmationModalInput, ApplicationOption, setApplicationOption, selectapplication, setSelectapplication, userApplications, setUserApplications, selectedRoles, setSelectedRoles, setConfirmationModalRlsMail, confirmationModalRlsMail, fetchUrlInReport, setfetchUrlInReport }}>
      {children}
    </AppContext.Provider>
  );
};
